export default "__VITE_ASSET__dlEhYYe2__"